module.exports = "<div id=\"snackbar\" class=\"{{ childShow ? 'show' : '' }}\">{{ childMessage }}</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/shared/snackbar_component/snackbar.component.html
// module id = ./src/app/component/shared/snackbar_component/snackbar.component.html
// module chunks = main